const authMiddleware = (authToken: string) => (next: any) => (req: any) => {
  req.fetchOpts.headers['x-token'] = authToken;
  return next(req);
};

export default authMiddleware;
